import { notification } from 'antd';

const NOTICE_KEY = 'company-suspended';
let activeNotificationApi = notification;

export const setCompanySuspensionNotificationApi = (api) => {
  activeNotificationApi = api;
  return () => {
    if (activeNotificationApi === api) activeNotificationApi = notification;
  };
};

export const isCompanySuspendedError = (error) =>
  error?.response?.status === 403 &&
  error?.response?.data?.code === 'COMPANY_SUSPENDED';

export const showCompanySuspensionNotice = (payload) => {
  if (typeof window === 'undefined' || payload?.code !== 'COMPANY_SUSPENDED') return;

  // Une réponse tardive d'une ancienne entreprise ne doit pas recouvrir le
  // contexte choisi entre-temps par un utilisateur multi-entreprises.
  try {
    const selectedId = Number(JSON.parse(localStorage.getItem('selectedCompany')));
    if (selectedId > 0 && payload.company_id && selectedId !== Number(payload.company_id)) {
      return;
    }
  } catch {
    // Aucune sélection exploitable : le refus de l'API reste affiché.
  }

  activeNotificationApi.error({
    key: NOTICE_KEY,
    message: 'Souscription suspendue',
    description: payload.message || 'L’accès à cette entreprise est suspendu.',
    duration: 0,
    placement: 'topRight',
  });
};

export const closeCompanySuspensionNotice = () => {
  activeNotificationApi.destroy(NOTICE_KEY);
  notification.destroy(NOTICE_KEY);
};
